<template>
    <CardComponent :withmin="false">
        <div class="d-flex align-items-center justify-content-between p-0 mb-4">
            <div class="d-flex flex-column">
                <h5 class="">{{ kpi?.title || '-' }}</h5>
                <span v-if="detail_type !== 'konsolidasi'" class="">{{ kpi?.nama_jabatan || '-' }}</span>
            </div>
            <router-link
                v-if="Object.keys(route_detail).length > 0"
                :to="route_detail"
                class="p-0"
            >
                <button class="btn btn-outline-secondary btn-xs mb-0 mt-0">Detail</button>
            </router-link>
        </div>

        <div class="d-flex flex-row gap-5 align-items-center">
            <div id="chart0">
                <DoughnutChart
                    :v_id="`chartgabungan_${index_kpi}`"
                    :width="150"
                    :height="150"
                    :labels="kpi?.chart?.label ? mapLabels(kpi?.chart?.label) : []"
                    :chartData="kpi?.chart?.data || []"
                    :colors="color_labels"
                    :isShowMaxValue="true"
                />
                </div>
            <div
                v-if="detail_type === 'konsolidasi'"
                class="d-flex flex-column w-100 gap-3"
            >
                <div class="d-flex flex-column">
                    <span>Target Konsolidasi</span>
                    <h3 class="fw-normal">
                        {{
                            new Intl.NumberFormat('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            }).format(kpi?.target_konsolidasi || '0')
                        }}
                    </h3>
                </div>
                <div class="d-flex flex-column">
                    <span>Target Individu</span>
                    <h3 class="fw-normal">
                        {{
                            new Intl.NumberFormat('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            }).format(kpi?.target_individu || '0')
                        }}
                    </h3>
                </div>
                <div class="d-flex flex-column">
                    <span>Selisih</span>
                    <h3 class="fw-normal">
                        {{
                            new Intl.NumberFormat('id-ID', {
                            style: 'currency',
                            currency: 'IDR',
                            minimumFractionDigits: 0,
                            }).format(kpi?.selisih || '0')
                        }}
                    </h3>
                </div>
            </div>
            <div v-else class="d-flex flex-column w-100 gap-3">
                <div
                    v-for="(item, index) in kpi?.chart?.label"
                    :key="index"
                    class="d-flex flex-column"
                >
                    <span>{{ labels?.[item] || item || '-' }}</span>
                    <h3 class="fw-normal">{{ kpi?.chart?.data?.[index] || kpi?.chart?.data?.[index] === 0 ? kpi?.chart?.data?.[index] +'%' : '-' }}</h3>
                </div>
            </div>
        </div>
        <div
            v-if="detail_list_sub && (detail_type === 'kpi' || detail_type === 'konsolidasi')"
            class="mt-4"
        >
            <div class="overflow-auto mb-2" style="max-height: 250px;">
                <list-view v-if="toogleListTarget" :thead="detail_type === 'kpi' ? thead_kpi : thead_konsolidasi">
                    <template v-slot:tbody>
                        <template v-if="detail_type === 'kpi' && kpi?.sub?.length > 0">
                            <tr v-for="(item, index) in kpi.sub" :key="index">
                                <td>{{ item?.title || '-' }}</td>
                                <td>
                                    <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                        }).format(item?.target || '0')
                                        }}
                                    </span>
                                    <span v-else>
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            minimumFractionDigits: 0,
                                        }).format(item?.target || '0')
                                        }} 
                                        <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '' }}</span>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                        }).format(item?.realisasi || '0')
                                        }}
                                    </span>
                                    <span v-else>
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            minimumFractionDigits: 0,
                                        }).format(item?.realisasi || '0')
                                        }} 
                                        <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '' }}</span>
                                    </span>
                                </td>
                                <td>{{ item?.pencapaian || item?.pencapaian === 0 ? item.pencapaian +'%' : '-' }}</td>
                            </tr>
                        </template>
                        <template v-else-if="detail_type === 'konsolidasi' && kpi?.daftar_pegawai_target?.length > 0">
                            <tr v-for="(item, index) in kpi.daftar_pegawai_target" :key="index">
                                <td>{{ item?.name || '-' }}</td>
                                <td>
                                    <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                        }).format(item?.target || '0')
                                        }}
                                    </span>
                                    <span v-else>
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            minimumFractionDigits: 0,
                                        }).format(item?.target || '0')
                                        }} 
                                        <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '' }}</span>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            style: 'currency',
                                            currency: 'IDR',
                                            minimumFractionDigits: 0,
                                        }).format(item?.realisasi || '0')
                                        }}
                                    </span>
                                    <span v-else>
                                        {{
                                        new Intl.NumberFormat('id-ID', {
                                            minimumFractionDigits: 0,
                                        }).format(item?.realisasi || '0')
                                        }} 
                                        <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '' }}</span>
                                    </span>
                                </td>
                                <td>{{ item?.pencapaian || item?.pencapaian === 0 ? item.pencapaian +'%' : '-' }}</td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td :colspan="4" class="text-center">Data tidak ditemukan.</td>
                        </tr>
                    </template>
                </list-view>
            </div>
            <button type="button" class="btn btn-link p-0 mb-0" @click="toogleListTarget=!toogleListTarget">{{ toogleListTarget ? "Sembunyikan" : (detail_type === 'kpi' ? "Lihat Sub KPI" : 'Lihat Daftar Karyawan') }}</button>
        </div>

        <template v-if="detail_type === 'konsolidasi'">
            <hr>
            <span class="mb-2">Target Realisasi</span>
            <div class="d-flex flex-row gap-5 align-items-center">
                <div id="chart-1">
                    <DoughnutChart
                        :v_id="`chartgabungan_realisasi_${index_kpi}`"
                        :width="150"
                        :height="150"
                        :labels="kpi?.chart_realisasi?.label ? mapLabels(kpi?.chart_realisasi?.label) : []"
                        :chartData="kpi?.chart_realisasi?.data || []"
                        :colors="color_labels"
                        :isShowMaxValue="true"
                    />
                </div>
                <div
                    class="d-flex flex-column w-100 gap-3"
                >
                    <div class="d-flex flex-column">
                        <span>Target Konsolidasi</span>
                        <h3 class="fw-normal">
                            {{
                                new Intl.NumberFormat('id-ID', {
                                style: 'currency',
                                currency: 'IDR',
                                minimumFractionDigits: 0,
                                }).format(kpi?.target_konsolidasi || '0')
                            }}
                        </h3>
                    </div>
                    <div class="d-flex flex-column">
                        <span>Realisasi Individu</span>
                        <h3 class="fw-normal">
                            {{
                                new Intl.NumberFormat('id-ID', {
                                style: 'currency',
                                currency: 'IDR',
                                minimumFractionDigits: 0,
                                }).format(kpi?.target_individu || '0')
                            }}
                        </h3>
                    </div>
                    <div class="d-flex flex-column">
                        <span>Selisih</span>
                        <h3 class="fw-normal">
                            {{
                                new Intl.NumberFormat('id-ID', {
                                style: 'currency',
                                currency: 'IDR',
                                minimumFractionDigits: 0,
                                }).format(kpi?.selisih || '0')
                            }}
                        </h3>
                    </div>
                </div>
            </div>

            <div
                class="mt-4"
            >
                <div class="overflow-auto mb-2" style="max-height: 250px;">
                    <list-view v-if="toogleListRealisasi" :thead="detail_type === 'kpi' ? thead_kpi : thead_konsolidasi">
                        <template v-slot:tbody>
                            <template v-if="kpi?.daftar_pegawai_realisasi?.length > 0">
                                <tr v-for="(item, index) in kpi.daftar_pegawai_realisasi" :key="index">
                                    <td>{{ item?.name || '-' }}</td>
                                    <td>
                                        <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                            {{
                                            new Intl.NumberFormat('id-ID', {
                                                style: 'currency',
                                                currency: 'IDR',
                                                minimumFractionDigits: 0,
                                            }).format(item?.target || '0')
                                            }}
                                        </span>
                                        <span v-else>
                                            {{
                                            new Intl.NumberFormat('id-ID', {
                                                minimumFractionDigits: 0,
                                            }).format(item?.target || '0')
                                            }} 
                                            <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '' }}</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item?.satuan?.toLowerCase() === 'rupiah'">
                                            {{
                                            new Intl.NumberFormat('id-ID', {
                                                style: 'currency',
                                                currency: 'IDR',
                                                minimumFractionDigits: 0,
                                            }).format(item?.realisasi || '0')
                                            }}
                                        </span>
                                        <span v-else>
                                            {{
                                            new Intl.NumberFormat('id-ID', {
                                                minimumFractionDigits: 0,
                                            }).format(item?.realisasi || '0')
                                            }} 
                                            <span class="text-capitalize">{{ (item?.satuan?.toLowerCase() === 'persen' ? '%' : item?.satuan) || '' }}</span>
                                        </span>
                                    </td>
                                    <td>{{ item?.pencapaian || item?.pencapaian === 0 ? item.pencapaian +'%' : '-' }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td :colspan="4" class="text-center">Data tidak ditemukan.</td>
                            </tr>
                        </template>
                    </list-view>
                </div>
                <button type="button" class="btn btn-link p-0 mb-0" @click="toogleListRealisasi=!toogleListRealisasi">{{ toogleListRealisasi ? "Sembunyikan" : (detail_type === 'kpi' ? "Lihat Sub KPI" : 'Lihat Daftar Karyawan') }}</button>
            </div>
        </template>

    </CardComponent>
</template>

<script>
import DoughnutChart from "../components/DoughnutChart.vue";
import CardComponent from "./CardComponent.vue";
import ListView from "./ListView.vue";

export default {
    name: "RealisasiGabunganCard",
    props: {
        kpi: {
            type: [Array, Object],
            default: () => {}
        },
        detail_list_sub: {
            type: Boolean,
            default: true,
        },
        detail_type: {
            type: String,
            default: 'kpi',
        },
        index_kpi: {
            type: [Number,String],
            default: 0,
        },
    },
    components: {
        DoughnutChart,
        CardComponent,
        ListView,
    },
    data() {
        return {
            toogleListTarget: false,
            toogleListRealisasi: false,
            thead_kpi: ['Sub KPI', 'Target', 'Realisasi', 'Pencapaian'],
            thead_konsolidasi: ['Nama Karyawan', 'Target', 'Realisasi', 'Pencapaian'],
            labels: {
                belum_dikerjakan: 'Belum Terealisasi',
                sudah_dikerjakan: 'Sudah Terealisasi',
            },
            color_labels: [
                '#0385F3',
                '#D9EAFE',
            ],
            chartData: {
                labels: ['Target', 'Realisasi'],
                datasets: [{
                    data: [35, 75],
                    backgroundColor: [
                        '#0385F3',
                        '#D9EAFE',
                    ]
                }]
            },
        }
    },
    computed: {
        route_detail() {
            let route = {};
            switch (this.detail_type) {
                case 'kpi':
                    route = {
                        name: 'Laporan Gabungan KPI Detail',
                        params: {
                            kpi_id: this.kpi.id
                        },
                    };
                    break;

                case 'kpi_detail':
                    route = {
                        name: 'Laporan Gabungan Sub KPI Detail',
                        params: {
                            kpi_id: this.$route.params?.kpi_id,
                            sub_kpi_id: this.kpi.id
                        },
                    };
                    break;
            
                default:
                    break;
            }
            return route;
        },
    },
    watch: {
        route_detail() {},
    },
    methods: {
        mapLabels(labels) {
            return labels.map(item => this.labels?.[item] || item || '-')
        },
    },
}
</script>